import * as identify from "utils/treeUtils";
import cx from "classnames";
import { NodeTitle } from "components/ProjectTree/components/NodeTitle";
import { EditNodeTypes } from "variables";
import { Icon } from "components/Icon/Icon";
import React from "react";
import type { defaultOptions } from "variables/nodeDefaultOptions";
import type { AnyProduct, Product, ProductAccessory } from "interfaces/schemas";
import type {
  NavigateToCustomProductProps,
  NavigateToProductProps,
} from "interfaces/product/product.types";

type ProductDetailsProps = {
  options: typeof defaultOptions;
  productName: string;
  presentation: string | null;
  navigateToProduct: (props: NavigateToProductProps) => void;
  isPasteMode: boolean;
  isEditMode: boolean | string;
  setIsEditMode: React.Dispatch<React.SetStateAction<boolean | string>>;
  handleUpdateProductName: (productName: string) => void;
  handleToggleEditMode: (type: string | boolean) => void;
  navigateToCustomProduct: (props: NavigateToCustomProductProps) => void;
  data: AnyProduct;
};

export const ProductDetails = ({
  options,
  productName,
  presentation,
  navigateToProduct,
  isPasteMode,
  isEditMode,
  setIsEditMode,
  handleUpdateProductName,
  handleToggleEditMode,
  navigateToCustomProduct,
  data,
}: ProductDetailsProps) => {
  const onNavigateIconClick = () => {
    if (
      !isPasteMode &&
      !identify.isTroxNetcom(data) &&
      !identify.isCustomProduct(data)
    ) {
      navigateToProduct(data as Product | ProductAccessory);
    }
    if (
      !isPasteMode &&
      (identify.isTroxNetcom(data) || identify.isCustomProduct(data))
    ) {
      navigateToCustomProduct(data);
    }
  };

  return (
    <div
      className="d-flex flex-column flex-grow-1 overflow-hidden"
      style={{ minWidth: 0 }}
    >
      <div className="d-flex flex-row align-items-center gap-2">
        <NodeTitle
          title={productName}
          isEditMode={
            isEditMode === EditNodeTypes.TITLE && !identify.isTroxNetcom(data)
          }
          setIsEditMode={setIsEditMode}
          handleToggleEditMode={handleToggleEditMode}
          isEditable={!identify.isWizard(data) && !options.editNodeDisabled}
          handleUpdateTitle={handleUpdateProductName}
          nodeId={data.id}
        />
        {!identify.isWizard(data) && !options.configurationLinkDisabled && (
          <Icon
            className={cx(
              "text-gray-300",
              isPasteMode ? "cursor-not-allowed" : "cursor-pointer",
            )}
            data-testid="product-configurator-link-icon"
            iconName="arrow-up-right-square-regular"
            onClick={onNavigateIconClick}
          />
        )}
      </div>
      <span
        className="text-gray-400 text-truncate mt-2"
        style={{ minWidth: 0 }}
      >
        {presentation}
      </span>
    </div>
  );
};
